//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../axios-client';
import { getAxios, getBaseUrl } from './helpers';

/**
 * @return OK
 */
export function portfoliosGetList(config?: AxiosRequestConfig | undefined): Promise<Types.ListResultDtoOfLookupDtoOfGuid> {
    let url_ = getBaseUrl() + "/api/portfolios";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigPortfoliosGetList,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigPortfoliosGetList?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPortfoliosGetList(_response);
    });
}

function processPortfoliosGetList(response: AxiosResponse): Promise<Types.ListResultDtoOfLookupDtoOfGuid> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.ListResultDtoOfLookupDtoOfGuid>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ListResultDtoOfLookupDtoOfGuid>(null as any);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function portfoliosCreate(body?: Types.PortfolioCreateDto | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PortfolioDto> {
    let url_ = getBaseUrl() + "/api/portfolios";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPortfoliosCreate,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigPortfoliosCreate?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPortfoliosCreate(_response);
    });
}

function processPortfoliosCreate(response: AxiosResponse): Promise<Types.PortfolioDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.PortfolioDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PortfolioDto>(null as any);
}

/**
 * @return OK
 */
export function portfoliosGet(id: string, config?: AxiosRequestConfig | undefined): Promise<Types.PortfolioDto> {
    let url_ = getBaseUrl() + "/api/portfolios/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigPortfoliosGet,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigPortfoliosGet?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPortfoliosGet(_response);
    });
}

function processPortfoliosGet(response: AxiosResponse): Promise<Types.PortfolioDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.PortfolioDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PortfolioDto>(null as any);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function portfoliosUpdate(id: string, body?: Types.PortfolioUpdateDto | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PortfolioDto> {
    let url_ = getBaseUrl() + "/api/portfolios/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPortfoliosUpdate,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigPortfoliosUpdate?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPortfoliosUpdate(_response);
    });
}

function processPortfoliosUpdate(response: AxiosResponse): Promise<Types.PortfolioDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.PortfolioDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PortfolioDto>(null as any);
}

/**
 * @return OK
 */
export function portfoliosDelete(id: string, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/portfolios/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigPortfoliosDelete,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigPortfoliosDelete?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPortfoliosDelete(_response);
    });
}

function processPortfoliosDelete(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status === 204) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * @param start (optional) 
 * @param end (optional) 
 * @param includeTransactions (optional) 
 * @return OK
 */
export function portfoliosGetTimeSeries(id: string, start?: string | undefined, end?: string | undefined, includeTransactions?: boolean | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.ListResultDtoOfBucketDto> {
    let url_ = getBaseUrl() + "/api/portfolios/{id}/timeseries?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (start === null)
        throw new Error("The parameter 'start' cannot be null.");
    else if (start !== undefined)
        url_ += "Start=" + encodeURIComponent("" + start) + "&";
    if (end === null)
        throw new Error("The parameter 'end' cannot be null.");
    else if (end !== undefined)
        url_ += "End=" + encodeURIComponent("" + end) + "&";
    if (includeTransactions === null)
        throw new Error("The parameter 'includeTransactions' cannot be null.");
    else if (includeTransactions !== undefined)
        url_ += "IncludeTransactions=" + encodeURIComponent("" + includeTransactions) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigPortfoliosGetTimeSeries,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigPortfoliosGetTimeSeries?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPortfoliosGetTimeSeries(_response);
    });
}

function processPortfoliosGetTimeSeries(response: AxiosResponse): Promise<Types.ListResultDtoOfBucketDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.ListResultDtoOfBucketDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ListResultDtoOfBucketDto>(null as any);
}

/**
 * @param providerName (optional) 
 * @param accountIdentifier (optional) 
 * @return OK
 */
export function portfoliosGetSyncSettings(id: string, providerName?: string | undefined, accountIdentifier?: string | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.ListResultDtoOfSyncedAssetDto> {
    let url_ = getBaseUrl() + "/api/portfolios/{id}/sync-settings?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (providerName === null)
        throw new Error("The parameter 'providerName' cannot be null.");
    else if (providerName !== undefined)
        url_ += "providerName=" + encodeURIComponent("" + providerName) + "&";
    if (accountIdentifier === null)
        throw new Error("The parameter 'accountIdentifier' cannot be null.");
    else if (accountIdentifier !== undefined)
        url_ += "accountIdentifier=" + encodeURIComponent("" + accountIdentifier) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigPortfoliosGetSyncSettings,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigPortfoliosGetSyncSettings?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPortfoliosGetSyncSettings(_response);
    });
}

function processPortfoliosGetSyncSettings(response: AxiosResponse): Promise<Types.ListResultDtoOfSyncedAssetDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.ListResultDtoOfSyncedAssetDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ListResultDtoOfSyncedAssetDto>(null as any);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function portfoliosSort(portfolioId: string, body?: Types.PortfolioSortingDto | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PortfolioDto> {
    let url_ = getBaseUrl() + "/api/portfolios/{portfolioId}/sort";
    if (portfolioId === undefined || portfolioId === null)
      throw new Error("The parameter 'portfolioId' must be defined.");
    url_ = url_.replace("{portfolioId}", encodeURIComponent("" + portfolioId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPortfoliosSort,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigPortfoliosSort?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPortfoliosSort(_response);
    });
}

function processPortfoliosSort(response: AxiosResponse): Promise<Types.PortfolioDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.PortfolioDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PortfolioDto>(null as any);
}

/**
 * @return OK
 */
export function portfoliosDeleteSyncedPortfolio(id: string, syncedPortfolioId: string, config?: AxiosRequestConfig | undefined): Promise<Types.PortfolioDto> {
    let url_ = getBaseUrl() + "/api/portfolios/{id}/synced-portfolio/{syncedPortfolioId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (syncedPortfolioId === undefined || syncedPortfolioId === null)
      throw new Error("The parameter 'syncedPortfolioId' must be defined.");
    url_ = url_.replace("{syncedPortfolioId}", encodeURIComponent("" + syncedPortfolioId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigPortfoliosDeleteSyncedPortfolio,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigPortfoliosDeleteSyncedPortfolio?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPortfoliosDeleteSyncedPortfolio(_response);
    });
}

function processPortfoliosDeleteSyncedPortfolio(response: AxiosResponse): Promise<Types.PortfolioDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.PortfolioDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PortfolioDto>(null as any);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function portfoliosCreateSection(id: string, body?: Types.SectionCreateDto | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.SectionDto> {
    let url_ = getBaseUrl() + "/api/portfolios/{id}/sections";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPortfoliosCreateSection,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigPortfoliosCreateSection?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPortfoliosCreateSection(_response);
    });
}

function processPortfoliosCreateSection(response: AxiosResponse): Promise<Types.SectionDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.SectionDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SectionDto>(null as any);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function portfoliosUpdateSection(id: string, sectionId: string, body?: Types.SectionUpdateDto | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.SectionDto> {
    let url_ = getBaseUrl() + "/api/portfolios/{id}/sections/{sectionId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sectionId === undefined || sectionId === null)
      throw new Error("The parameter 'sectionId' must be defined.");
    url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPortfoliosUpdateSection,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigPortfoliosUpdateSection?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPortfoliosUpdateSection(_response);
    });
}

function processPortfoliosUpdateSection(response: AxiosResponse): Promise<Types.SectionDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.SectionDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.SectionDto>(null as any);
}

/**
 * @return OK
 */
export function portfoliosDeleteSection(id: string, sectionId: string, config?: AxiosRequestConfig | undefined): Promise<Types.PortfolioDto> {
    let url_ = getBaseUrl() + "/api/portfolios/{id}/sections/{sectionId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sectionId === undefined || sectionId === null)
      throw new Error("The parameter 'sectionId' must be defined.");
    url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigPortfoliosDeleteSection,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigPortfoliosDeleteSection?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPortfoliosDeleteSection(_response);
    });
}

function processPortfoliosDeleteSection(response: AxiosResponse): Promise<Types.PortfolioDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.PortfolioDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PortfolioDto>(null as any);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function portfoliosSortSection(id: string, sectionId: string, body?: Types.SectionSortingDto | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PortfolioDto> {
    let url_ = getBaseUrl() + "/api/portfolios/{id}/sections/{sectionId}/sort";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sectionId === undefined || sectionId === null)
      throw new Error("The parameter 'sectionId' must be defined.");
    url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPortfoliosSortSection,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigPortfoliosSortSection?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPortfoliosSortSection(_response);
    });
}

function processPortfoliosSortSection(response: AxiosResponse): Promise<Types.PortfolioDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.PortfolioDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PortfolioDto>(null as any);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function portfoliosMoveAsset(id: string, body?: Types.MoveAssetDto | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PortfolioDto> {
    let url_ = getBaseUrl() + "/api/portfolios/{id}/move-asset";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPortfoliosMoveAsset,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigPortfoliosMoveAsset?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPortfoliosMoveAsset(_response);
    });
}

function processPortfoliosMoveAsset(response: AxiosResponse): Promise<Types.PortfolioDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.PortfolioDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PortfolioDto>(null as any);
}

/**
 * @param portfolioIds (optional) 
 * @return OK
 */
export function portfoliosGetSectionLookup(portfolioIds?: string[] | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.ListResultDtoOfSectionLookupDto> {
    let url_ = getBaseUrl() + "/api/portfolios/sections/lookup?";
    if (portfolioIds === null)
        throw new Error("The parameter 'portfolioIds' cannot be null.");
    else if (portfolioIds !== undefined)
        portfolioIds && portfolioIds.forEach(item => { url_ += "portfolioIds=" + encodeURIComponent("" + item) + "&"; });
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigPortfoliosGetSectionLookup,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigPortfoliosGetSectionLookup?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPortfoliosGetSectionLookup(_response);
    });
}

function processPortfoliosGetSectionLookup(response: AxiosResponse): Promise<Types.ListResultDtoOfSectionLookupDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.ListResultDtoOfSectionLookupDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.ListResultDtoOfSectionLookupDto>(null as any);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function portfoliosAddAsset(id: string, sectionId: string, body?: Types.SectionAssetCreateDto | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PortfolioDto> {
    let url_ = getBaseUrl() + "/api/portfolios/{id}/sections/{sectionId}/assets";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sectionId === undefined || sectionId === null)
      throw new Error("The parameter 'sectionId' must be defined.");
    url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPortfoliosAddAsset,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigPortfoliosAddAsset?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPortfoliosAddAsset(_response);
    });
}

function processPortfoliosAddAsset(response: AxiosResponse): Promise<Types.PortfolioDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.PortfolioDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PortfolioDto>(null as any);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function portfoliosUpdateAsset(id: string, sectionId: string, assetId: string, body?: Types.SectionAssetUpdateDto | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PortfolioDto> {
    let url_ = getBaseUrl() + "/api/portfolios/{id}/sections/{sectionId}/assets/{assetId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sectionId === undefined || sectionId === null)
      throw new Error("The parameter 'sectionId' must be defined.");
    url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
    if (assetId === undefined || assetId === null)
      throw new Error("The parameter 'assetId' must be defined.");
    url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(body);

    let options_: AxiosRequestConfig = {
        ..._requestConfigPortfoliosUpdateAsset,
        ...config,
        data: content_,
        method: "PUT",
        url: url_,
        headers: {
            ..._requestConfigPortfoliosUpdateAsset?.headers,
            "Content-Type": "application/json",
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPortfoliosUpdateAsset(_response);
    });
}

function processPortfoliosUpdateAsset(response: AxiosResponse): Promise<Types.PortfolioDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.PortfolioDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PortfolioDto>(null as any);
}

/**
 * @return OK
 */
export function portfoliosDeleteAsset(id: string, sectionId: string, assetId: string, config?: AxiosRequestConfig | undefined): Promise<Types.PortfolioDto> {
    let url_ = getBaseUrl() + "/api/portfolios/{id}/sections/{sectionId}/assets/{assetId}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (sectionId === undefined || sectionId === null)
      throw new Error("The parameter 'sectionId' must be defined.");
    url_ = url_.replace("{sectionId}", encodeURIComponent("" + sectionId));
    if (assetId === undefined || assetId === null)
      throw new Error("The parameter 'assetId' must be defined.");
    url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigPortfoliosDeleteAsset,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigPortfoliosDeleteAsset?.headers,
            "Accept": "text/plain",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processPortfoliosDeleteAsset(_response);
    });
}

function processPortfoliosDeleteAsset(response: AxiosResponse): Promise<Types.PortfolioDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = JSON.parse(resultData200);
        return Promise.resolve<Types.PortfolioDto>(result200);

    } else if (status === 403) {
        const _responseText = response.data;
        let result403: any = null;
        let resultData403  = _responseText;
        result403 = JSON.parse(resultData403);
        return throwException("Forbidden", status, _responseText, _headers, result403);

    } else if (status === 401) {
        const _responseText = response.data;
        let result401: any = null;
        let resultData401  = _responseText;
        result401 = JSON.parse(resultData401);
        return throwException("Unauthorized", status, _responseText, _headers, result401);

    } else if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = JSON.parse(resultData400);
        return throwException("Bad Request", status, _responseText, _headers, result400);

    } else if (status === 404) {
        const _responseText = response.data;
        let result404: any = null;
        let resultData404  = _responseText;
        result404 = JSON.parse(resultData404);
        return throwException("Not Found", status, _responseText, _headers, result404);

    } else if (status === 501) {
        const _responseText = response.data;
        let result501: any = null;
        let resultData501  = _responseText;
        result501 = JSON.parse(resultData501);
        return throwException("Not Implemented", status, _responseText, _headers, result501);

    } else if (status === 500) {
        const _responseText = response.data;
        let result500: any = null;
        let resultData500  = _responseText;
        result500 = JSON.parse(resultData500);
        return throwException("Internal Server Error", status, _responseText, _headers, result500);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PortfolioDto>(null as any);
}
let _requestConfigPortfoliosGetList: Partial<AxiosRequestConfig> | null;
export function getPortfoliosGetListRequestConfig() {
  return _requestConfigPortfoliosGetList;
}
export function setPortfoliosGetListRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosGetList = value;
}
export function patchPortfoliosGetListRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosGetList = patch(_requestConfigPortfoliosGetList ?? {});
}

let _requestConfigPortfoliosCreate: Partial<AxiosRequestConfig> | null;
export function getPortfoliosCreateRequestConfig() {
  return _requestConfigPortfoliosCreate;
}
export function setPortfoliosCreateRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosCreate = value;
}
export function patchPortfoliosCreateRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosCreate = patch(_requestConfigPortfoliosCreate ?? {});
}

let _requestConfigPortfoliosGet: Partial<AxiosRequestConfig> | null;
export function getPortfoliosGetRequestConfig() {
  return _requestConfigPortfoliosGet;
}
export function setPortfoliosGetRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosGet = value;
}
export function patchPortfoliosGetRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosGet = patch(_requestConfigPortfoliosGet ?? {});
}

let _requestConfigPortfoliosUpdate: Partial<AxiosRequestConfig> | null;
export function getPortfoliosUpdateRequestConfig() {
  return _requestConfigPortfoliosUpdate;
}
export function setPortfoliosUpdateRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosUpdate = value;
}
export function patchPortfoliosUpdateRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosUpdate = patch(_requestConfigPortfoliosUpdate ?? {});
}

let _requestConfigPortfoliosDelete: Partial<AxiosRequestConfig> | null;
export function getPortfoliosDeleteRequestConfig() {
  return _requestConfigPortfoliosDelete;
}
export function setPortfoliosDeleteRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosDelete = value;
}
export function patchPortfoliosDeleteRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosDelete = patch(_requestConfigPortfoliosDelete ?? {});
}

let _requestConfigPortfoliosGetTimeSeries: Partial<AxiosRequestConfig> | null;
export function getPortfoliosGetTimeSeriesRequestConfig() {
  return _requestConfigPortfoliosGetTimeSeries;
}
export function setPortfoliosGetTimeSeriesRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosGetTimeSeries = value;
}
export function patchPortfoliosGetTimeSeriesRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosGetTimeSeries = patch(_requestConfigPortfoliosGetTimeSeries ?? {});
}

let _requestConfigPortfoliosGetSyncSettings: Partial<AxiosRequestConfig> | null;
export function getPortfoliosGetSyncSettingsRequestConfig() {
  return _requestConfigPortfoliosGetSyncSettings;
}
export function setPortfoliosGetSyncSettingsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosGetSyncSettings = value;
}
export function patchPortfoliosGetSyncSettingsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosGetSyncSettings = patch(_requestConfigPortfoliosGetSyncSettings ?? {});
}

let _requestConfigPortfoliosSort: Partial<AxiosRequestConfig> | null;
export function getPortfoliosSortRequestConfig() {
  return _requestConfigPortfoliosSort;
}
export function setPortfoliosSortRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosSort = value;
}
export function patchPortfoliosSortRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosSort = patch(_requestConfigPortfoliosSort ?? {});
}

let _requestConfigPortfoliosDeleteSyncedPortfolio: Partial<AxiosRequestConfig> | null;
export function getPortfoliosDeleteSyncedPortfolioRequestConfig() {
  return _requestConfigPortfoliosDeleteSyncedPortfolio;
}
export function setPortfoliosDeleteSyncedPortfolioRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosDeleteSyncedPortfolio = value;
}
export function patchPortfoliosDeleteSyncedPortfolioRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosDeleteSyncedPortfolio = patch(_requestConfigPortfoliosDeleteSyncedPortfolio ?? {});
}

let _requestConfigPortfoliosCreateSection: Partial<AxiosRequestConfig> | null;
export function getPortfoliosCreateSectionRequestConfig() {
  return _requestConfigPortfoliosCreateSection;
}
export function setPortfoliosCreateSectionRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosCreateSection = value;
}
export function patchPortfoliosCreateSectionRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosCreateSection = patch(_requestConfigPortfoliosCreateSection ?? {});
}

let _requestConfigPortfoliosUpdateSection: Partial<AxiosRequestConfig> | null;
export function getPortfoliosUpdateSectionRequestConfig() {
  return _requestConfigPortfoliosUpdateSection;
}
export function setPortfoliosUpdateSectionRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosUpdateSection = value;
}
export function patchPortfoliosUpdateSectionRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosUpdateSection = patch(_requestConfigPortfoliosUpdateSection ?? {});
}

let _requestConfigPortfoliosDeleteSection: Partial<AxiosRequestConfig> | null;
export function getPortfoliosDeleteSectionRequestConfig() {
  return _requestConfigPortfoliosDeleteSection;
}
export function setPortfoliosDeleteSectionRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosDeleteSection = value;
}
export function patchPortfoliosDeleteSectionRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosDeleteSection = patch(_requestConfigPortfoliosDeleteSection ?? {});
}

let _requestConfigPortfoliosSortSection: Partial<AxiosRequestConfig> | null;
export function getPortfoliosSortSectionRequestConfig() {
  return _requestConfigPortfoliosSortSection;
}
export function setPortfoliosSortSectionRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosSortSection = value;
}
export function patchPortfoliosSortSectionRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosSortSection = patch(_requestConfigPortfoliosSortSection ?? {});
}

let _requestConfigPortfoliosMoveAsset: Partial<AxiosRequestConfig> | null;
export function getPortfoliosMoveAssetRequestConfig() {
  return _requestConfigPortfoliosMoveAsset;
}
export function setPortfoliosMoveAssetRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosMoveAsset = value;
}
export function patchPortfoliosMoveAssetRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosMoveAsset = patch(_requestConfigPortfoliosMoveAsset ?? {});
}

let _requestConfigPortfoliosGetSectionLookup: Partial<AxiosRequestConfig> | null;
export function getPortfoliosGetSectionLookupRequestConfig() {
  return _requestConfigPortfoliosGetSectionLookup;
}
export function setPortfoliosGetSectionLookupRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosGetSectionLookup = value;
}
export function patchPortfoliosGetSectionLookupRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosGetSectionLookup = patch(_requestConfigPortfoliosGetSectionLookup ?? {});
}

let _requestConfigPortfoliosAddAsset: Partial<AxiosRequestConfig> | null;
export function getPortfoliosAddAssetRequestConfig() {
  return _requestConfigPortfoliosAddAsset;
}
export function setPortfoliosAddAssetRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosAddAsset = value;
}
export function patchPortfoliosAddAssetRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosAddAsset = patch(_requestConfigPortfoliosAddAsset ?? {});
}

let _requestConfigPortfoliosUpdateAsset: Partial<AxiosRequestConfig> | null;
export function getPortfoliosUpdateAssetRequestConfig() {
  return _requestConfigPortfoliosUpdateAsset;
}
export function setPortfoliosUpdateAssetRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosUpdateAsset = value;
}
export function patchPortfoliosUpdateAssetRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosUpdateAsset = patch(_requestConfigPortfoliosUpdateAsset ?? {});
}

let _requestConfigPortfoliosDeleteAsset: Partial<AxiosRequestConfig> | null;
export function getPortfoliosDeleteAssetRequestConfig() {
  return _requestConfigPortfoliosDeleteAsset;
}
export function setPortfoliosDeleteAssetRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosDeleteAsset = value;
}
export function patchPortfoliosDeleteAssetRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigPortfoliosDeleteAsset = patch(_requestConfigPortfoliosDeleteAsset ?? {});
}